// @ts-nocheck
import React, { Component, Suspense } from 'react';
import LoadingPlaceholder from '../../components/common/Spinners';
import Loadable from 'react-loadable';
import settings from "../../config"

// Lazy loading and code splitting -
// Derieved idea from https://blog.logrocket.com/lazy-loading-components-in-react-16-6-6cea535c0b52
const loading = () => <LoadingPlaceholder />;

const VerticalLayout = Loadable({
    loader: () => import('../../layouts/Vertical'),
    render(loaded, props) {
        let Component = loaded.default;
        return <Component {...props} />;
    },
    loading,
});


/**
 * Exports the component with layout wrapped to it
 * @param {} WrappedComponent
 */
const withLayout = (WrappedComponent: any) => {
    return class extends Component {
        render() {
            const showLayout = settings.SHOW_LAYOUT;

            const render = !showLayout ?
                <Suspense fallback={loading()}>
                    <WrappedComponent {...this.props} />
                </Suspense>
                :
                <Suspense fallback={loading()}>
                    <VerticalLayout {...this.props}>
                        <WrappedComponent {...this.props} />
                    </VerticalLayout>
                </Suspense>;
            return render;
        }
    };
};

export default withLayout;
